import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
export const useOpenCopilot = () => {
  return useSendOnCopilotChannel('OPEN_COPILOT');
};